import { render, staticRenderFns } from "./MyHead.vue?vue&type=template&id=0f70f878&scoped=true"
import script from "./MyHead.vue?vue&type=script&lang=js"
export * from "./MyHead.vue?vue&type=script&lang=js"
import style0 from "./MyHead.vue?vue&type=style&index=0&id=0f70f878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70f878",
  null
  
)

export default component.exports